import { Box, Modal, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { BOTTOM_MENU_HEIGHT } from "Components/Layout/Menu/BottomMenu";
import { Resources, useResource } from "Translations/Resources";
import type { ReactNode } from "react";
import { Header } from "Components/Shared/ValueTile/Components/HintDetail/Header";

const VERTICAL_MARGIN = "100px";

type HintDetailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  content: ReactNode;
  title: string;
};

export const HintDetailModal = ({
  isOpen,
  onClose,
  content,
  title,
}: HintDetailModalProps) => {
  const { t } = useResource();

  const maxHeight = `calc(100dvh - ${VERTICAL_MARGIN} - ${BOTTOM_MENU_HEIGHT})`;

  return (
    <Modal open={isOpen} onClose={onClose} disableRestoreFocus>
      <Box
        role="dialog"
        aria-modal="true"
        sx={({ palette, shadows }) => ({
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: `1px solid ${palette.grey[200]}`,
          boxShadow: shadows[3],
          borderRadius: "10px",
          width: { xs: "92vw", sm: "min(92vw, 600px)" },
          maxWidth: 600,
          maxHeight,
          display: "flex",
          overflow: "hidden",
          backgroundColor: palette.background.paper,
        })}
      >
        <Box
          p={5}
          flex={1}
          position="relative"
          maxHeight="inherit"
          sx={{ overflowY: "auto" }}
        >
          <IconButton
            aria-label={t(Resources.Common.Back)}
            onClick={onClose}
            size="small"
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
          >
            <Close fontSize="small" />
          </IconButton>
          <Header title={title} />
          {content}
        </Box>
      </Box>
    </Modal>
  );
};
